import muster from '@dbk-legacy/muster';
import { variable, redirectOn } from '@dbk-legacy/muster/helpers';
import { getValues, ref } from '@dbk-legacy/muster/utils';
import { Platform, AsyncStorage } from 'react-native';
import calendar from './calendar-modal';
import ui from '../data/ui.json';
import startOfToday from 'date-fns/start_of_today';
import end_of_month from 'date-fns/end_of_month';
import end_of_year from 'date-fns/end_of_year'
import format from 'date-fns/format';
import { addDays, addMonths, dateDiff, ymd } from '../utils/date';
import startOfYesterday from 'date-fns/start_of_yesterday';
import startOfMonth from 'date-fns/start_of_month';
import { encode } from 'base-64';
import Guid from '../utils/guid';
import isValidJsonString from '../utils/is-valid-json-string';

export default () => {

  const today = startOfToday();
  const yesterday = startOfYesterday();
  const past7Days = addDays(-6, yesterday);
  const past30Days = addDays(-30, yesterday);
  const startOfYTD = new Date(yesterday.getFullYear()-1, yesterday.getMonth(), yesterday.getDate());
  const startOfYear = new Date(new Date().getFullYear(), 0, 1);

  return muster()
   .path('downloads.onCalendarDone', {
     call: async ({ req }, { get, set, call }) => {
        const [messages] = await getValues(get('i18n.messages'));
        var startDate= req.args[0].from ? req.args[0].from : req.args[0].to;
        var endDate= req.args[0].to ? req.args[0].to : req.args[0].from;

        if(startDate != undefined || endDate != undefined){
          await set('downloads.startDate', ymd(startDate));
          await set('downloads.endDate', ymd(endDate));
          await set('downloads.isDateBarClickable', true);
        }
      },
    })

    .import('downloads.calendar', calendar(), {
      onDone: ref('downloads.onCalendarDone')
    })
    .path('downloads.clearDates', {
      call: ({ req }, { set }) => {
        set('downloads.startDate', ymd(past7Days));
        set('downloads.endDate', ymd(yesterday));
        set('downloads.isDateBarClickable', false);
      },
    })
    .path('downloads.excelData', {
      call: async ({ req, res }, { get, set }) => {
        const requestData  = req.args[0];
        const base64 = encode(JSON.stringify(requestData));
        const guidStr = Guid();
        const [oReturn] = await getValues(get(`roster.data.positionDownloads.downloads["${base64}"]["${guidStr}"]`));
        isValidJsonString(oReturn).then(async(data) => {
          await set('downloads.result', data);
        });
      },
    })
    .path('downloads.resetDates', {
        call: ({ req }, { set }) => {
          set('downloads.startDate', ymd(past7Days));
          set('downloads.endDate', ymd(yesterday));
        },
      })
    .path('downloads.startDate', variable( ymd(past7Days) ))
    .path('downloads.endDate', variable( ymd(yesterday)))
    .path('downloads.isDateBarClickable', variable(false))
    .path('downloads.result', variable())
    .path('downloads.correspondenceStatementsList', variable());

};
